"use strict";
import {onFind} from "@elements/init-modules-in-scope";

export function init() {
    onFind('.js-nav-logo', function (navLogo) {
        window.onscroll = function() {
            let scrollTop = window.pageYOffset;
            if(scrollTop > 20){
                navLogo.classList.add('is-hidden');
            }else{
                navLogo.classList.remove('is-hidden');
            }
        };
    });
}